import axios from "axios";
import { BASE_URL } from "./api";


export async function getUserGroupAdminUsers(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/user-group-admin/users/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function getManagedGroups(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/user-group-admin/managed-groups/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function addUserToGroup(token, userId, groupId) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/user-group-admin/add-to-group/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { user_id: userId, group_id: groupId },
    }).then((r) => r.data);
}


export async function removeUserFromGroup(token, userId, groupId) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/user-group-admin/remove-from-group/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { user_id: userId, group_id: groupId },
    }).then((r) => r.data);
}


export async function getUserGroupRecentChanges(token, limit = 15) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/user-group-admin/recent-changes/?limit=${limit}`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function createCategory(token, payload) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-categories/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: payload,
    }).then((r) => r.data);
}


export async function updateCategory(token, id, payload) {
    return axios({
        method: 'patch',
        url: `${BASE_URL}/expense-categories/${id}/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: payload,
    }).then((r) => r.data);
}


export async function deleteCategory(token, id) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/expense-categories/${id}/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function getEngagementPickerAdmin(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/expense-picker-engagements-admin/`,
        headers: { 'Authorization': `Token ${token}` },
    }).then((r) => r.data);
}


export async function toggleEngagementInPicker(token, engagementId, enabled) {
    return axios({
        method: 'post',
        url: `${BASE_URL}/expense-picker-engagements-admin/toggle/`,
        headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        data: { engagement_id: engagementId, enabled },
    }).then((r) => r.data);
}
